export default "__VITE_ASSET__DLwBcCHr__"